import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import { DocumentLogEntry } from "@stratify/shared";

interface LogsListProps {
  logs: DocumentLogEntry[];
  loading: boolean;
  error: string | null;
}

export const LogsList: React.FC<LogsListProps> = ({ logs, loading, error }) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (logs.length === 0) {
    return (
      <Box p={3}>
        <Typography color="textSecondary">No logs available</Typography>
      </Box>
    );
  }

  return (
    <List>
      {logs.map((log, index) => (
        <ListItem
          key={index}
          sx={{
            border: "1px solid rgba(0,0,0,0.12)",
            borderLeft: 3,
            borderLeftColor:
              log.status === "success"
                ? "success.main"
                : log.status === "failure"
                  ? "error.main"
                  : "info.main",
            bgcolor: "background.paper",
            boxShadow: "none",
            borderRadius: 1,
            marginBottom: 2,
          }}
        >
          <ListItemText
            primary={
              <Typography variant="subtitle1" component="div">
                {log.event}
              </Typography>
            }
            secondary={
              <>
                <Typography
                  component="span"
                  variant="body2"
                  color="textSecondary"
                  display="block"
                >
                  {log.timestamp.toDate().toLocaleString()}
                </Typography>
                {log.details && (
                  <Typography
                    component="span"
                    variant="body2"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}
                  >
                    {log.details}
                  </Typography>
                )}
              </>
            }
          />
        </ListItem>
      ))}
    </List>
  );
};
